import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

// import { Stack } from '../'
import { IconProps } from '../icons'

const RightInvertedComa = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    fill="none"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 220 148"
    rotation={180}
    {...props}
  >
    <Path
      d="M4.919 63.94C1.789 68.41 0 74.67 0 80.483v57.68C0 144.423 3.577 148 10.285 148h74.227c6.707 0 10.285-3.577 10.285-9.837v-57.68c0-6.26-3.578-9.837-10.285-9.837h-34.43L88.983 9.39C92.56 4.47 89.43 0 84.512 0H59.92C54.106 0 49.634 2.683 46.95 6.707L4.92 63.94Zm125.203 0c-3.13 4.47-4.919 10.73-4.919 16.543v57.68c0 6.26 3.577 9.837 10.285 9.837h74.227c6.708 0 10.285-3.577 10.285-9.837v-57.68c0-6.26-3.577-9.837-10.285-9.837h-34.43L214.187 9.39c3.577-4.919.447-9.39-4.472-9.39h-24.593c-5.813 0-10.285 2.683-12.968 6.707L130.122 63.94Z"
      fill="#36383F"
    />
  </Svg>
)

export default RightInvertedComa
